module.exports = __webpack_public_path__ + "img/zanlitea.a5515bc5.png";